import React from "react";
import { NavLink as Link } from "react-router-dom";
import snowflakeImage from "../images/CIRA.png";
import noaa from "../images/noaa_digital_logo.svg";
import ai2es from "../images/ai2es.png";
import "../css/nav.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="nav-left">
        <div className="nav-logos">
          <a className="logo-link" href="https://www.cira.colostate.edu/">
            <img className="logo-img" alt="CIRA" src={snowflakeImage} />
          </a>
          <a className="logo-link" href="https://www.noaa.gov/">
            <img className="logo-img" alt="NOAA" src={noaa} />
          </a>
          <a className="logo-link" href="https://www.ai2es.org/">
            <img className="logo-img" alt="AI2ES" src={ai2es} />
          </a>
        </div>
        <div className="nav-description">
          <span className="nav-title">Real-time visualizations for purely AI-based weather models.</span>
          <a
            href="https://rammb.cira.colostate.edu/resources/experimental_products_disclaimer.asp"
            className="nav-disclaimer"
          >
            Products are experimental
          </a>
          <br />
          <span className="nav-author">Developed by Dr. Jacob Radford</span>
        </div>
      </div>
      <div className="nav-links">
        <Link to="/" className="nav-tab">Models</Link>
        <Link to="/faq" className="nav-tab">FAQ</Link>
        <Link to="/contact" className="nav-tab">Contact Us</Link>
      </div>
    </nav>
  );
};

export default Navbar;
